import HttpRequest from './axios'
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseApiUrl.dev : config.baseApiUrl.pro

const axios = new HttpRequest(baseUrl)
export default axios
